// extracted by mini-css-extract-plugin
export var sbShowMain = "breadcrumbs-module--sb-show-main--1BHTf";
export var breadcrumbs = "breadcrumbs-module--breadcrumbs--32kLD";